import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import navigationData from '../data/navigationData';
import './Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  const isActive = (path) => location.pathname === path;

  return (
    <header className={`navbar ${scrolled ? 'navbar--scrolled' : ''}`}>
      <div className="container navbar__inner">

        <Link to="/" className="navbar__logo">
          <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="PROVIRTUES" className="navbar__logo-img" />
        </Link>

        <nav className="navbar__links" aria-label="Main navigation">
          {navigationData.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`navbar__link ${isActive(item.path) ? 'active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <Link to="/contact" className="btn btn-primary navbar__cta">
          Discuss Your Technology Needs
        </Link>

        <button
          type="button"
          className={`navbar__ham ${menuOpen ? 'open' : ''}`}
          onClick={() => setMenuOpen(v => !v)}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          <span /><span /><span />
        </button>
      </div>

      {/* Mobile menu */}
      <div className={`navbar__mobile ${menuOpen ? 'navbar__mobile--open' : ''}`} aria-hidden={!menuOpen}>
        <nav className="navbar__mobile-nav">
          {navigationData.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`navbar__mobile-link ${isActive(item.path) ? 'active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
        </nav>
        <Link to="/contact" className="btn btn-primary" style={{ marginTop: 20, justifyContent: 'center' }}>
          Discuss Your Technology Needs
        </Link>
      </div>
    </header>
  );
}
